// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6c57412d","239":"6fc1ad08","455":"eb9bfee6"}[chunkId] + ".chunk.js";
};